import React from 'react';
import { useAuth } from '../../Commun/contexts/AuthContext';

// boubaker 23/08/2026 - Helpers & en-tête partagés des pages d'impression Academy
// (même présentation que l'impression planning du SchedulerPage).

export const PRINT_DAY_SHORT = ['DIM', 'LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM'];

// "août 2026" → "Août 2026" (toLocaleDateString renvoie tout en minuscules)
export function capitalizeFirst(s: string): string {
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

// "2026-08-02" → "DIM 02 Août"
export function formatPrintDay(dateStr: string): string {
    const d = new Date(dateStr + 'T00:00:00');
    if (isNaN(d.getTime())) return dateStr;
    return `${PRINT_DAY_SHORT[d.getDay()] || ''} ${String(d.getDate()).padStart(2, '0')} ${capitalizeFirst(d.toLocaleDateString('fr-FR', { month: 'long' }))}`;
}

// "2026-08-02" → "Août 2026"
export function formatMonthYear(anchorDate: string): string {
    const d = new Date(anchorDate + 'T00:00:00');
    if (isNaN(d.getTime())) return '';
    return capitalizeFirst(d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }));
}

interface PrintAgencyHeaderProps {
    /** Titre affiché sous l'en-tête, centré au milieu de la page (seul sur sa ligne) */
    title?: string;
    subtitle?: string;
    showBorderBottom?: boolean;
}

/**
 * En-tête d'édition : logo + coordonnées de l'agence connectée.
 * Le titre est affiché sous l'en-tête, centré au milieu de la page seul sur sa ligne.
 * Source : contexte Auth (rempli au login) — même source que FinancialPage.
 */
const PrintAgencyHeader: React.FC<PrintAgencyHeaderProps> = ({ title, subtitle, showBorderBottom = true }) => {
    const { user } = useAuth();

    return (
        <div style={{ width: '100%', marginBottom: 14 }}>
            <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                borderBottom: showBorderBottom ? '2px solid #111' : undefined,
                paddingBottom: showBorderBottom ? 8 : undefined,
                marginBottom: title ? 12 : 0
            }}>
                <tbody>
                    <tr>
                        <td style={{ width: 90, verticalAlign: 'middle' }}>
                            {user?.dosLogo ? (
                                <img src={user.dosLogo} alt="logo" style={{ maxWidth: 80, maxHeight: 80, objectFit: 'contain' }} />
                            ) : null}
                        </td>
                        <td style={{ verticalAlign: 'middle', fontSize: 11 }}>
                            <strong style={{ fontSize: 14 }}>{user?.dosLib || user?.agency || ''}</strong><br />
                            {user?.dosAdr1 ? (<>{user.dosAdr1}<br /></>) : null}
                            {user?.dosEmail ? <>Email : {user.dosEmail}<br /></> : null}
                            {user?.dosTelph ? <>Tél : {user.dosTelph}</> : null}
                        </td>
                    </tr>
                </tbody>
            </table>

            {title ? (
                <div style={{
                    textAlign: 'center',
                    margin: '14px auto 16px auto',
                    width: '100%'
                }}>
                    <div style={{
                        fontSize: 18,
                        fontWeight: 'bold',
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                        color: '#111',
                        lineHeight: 1.3
                    }}>
                        {title}
                    </div>
                    {subtitle ? (
                        <div style={{
                            fontSize: 12,
                            color: '#555',
                            marginTop: 4,
                            fontWeight: 500
                        }}>
                            {subtitle}
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default PrintAgencyHeader;
